import { merge } from "lodash";
import { config } from "src/config/config";
import { PUBLIC_ASSET_ACTIONS } from "src/actions/public_asset_actions";
import { APICallStatus } from "src/service/api_types";
import { checkApiStatus } from "src/service/utils";
import moment from "moment";

const defaultState = {
  saleAssetsInTheBrand: {
    pageNumber: 0,
    status: { status: APICallStatus.INIT },
    data: null,
  },
  rentalAssetsInTheBrand: {
    pageNumber: 0,
    status: { status: APICallStatus.INIT },
    data: null,
  },
  groupsInTheBrand: {
    pageNumber: 0,
    status: { status: APICallStatus.INIT },
    data: null,
  },
  tradingAssets: {
    pageNumber: 0,
    status: { status: APICallStatus.INIT },
    data: null,
  },
  tradableListedAssets: {
    pageNumber: 0,
    status: { status: APICallStatus.INIT },
    data: null,
  },
};

export const publicAssetsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case PUBLIC_ASSET_ACTIONS.GET_SALE_ASSETS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.GET_SALE_ASSETS_BY_BRAND: ",
          action.data
        );
      }

      let assets = action.data.response;
      return {
        ...state,
        saleAssetsInTheBrand: {
          pageNumber:
            assets && assets.length
              ? action.data.pageNumber
              : state.saleAssetsInTheBrand.pageNumber,
          data: assets,
          status: checkApiStatus(action.data.ajaxStat, null),
        },
      };
    }
    case PUBLIC_ASSET_ACTIONS.INIT_SALE_ASSETS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.INIT_SALE_ASSETS_BY_BRAND: ",
          action.data
        );
      }

      let newState = {
        saleAssetsInTheBrand: {
          status: { status: APICallStatus.INIT },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.START_SALE_ASSETS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.START_SALE_ASSETS_BY_BRAND: ",
          action.data
        );
      }

      let newState = {
        saleAssetsInTheBrand: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.GET_RENTAL_ASSETS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.GET_RENTAL_ASSETS_BY_BRAND: ",
          action.data
        );
      }

      let assets = action.data.response;
      return {
        ...state,
        rentalAssetsInTheBrand: {
          pageNumber:
            assets && assets.length
              ? action.data.pageNumber
              : state.rentalAssetsInTheBrand.pageNumber,
          data: assets,
          status: checkApiStatus(action.data.ajaxStat, null),
        },
      };
    }

    case PUBLIC_ASSET_ACTIONS.INIT_RENTAL_ASSETS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.INIT_RENTAL_ASSETS_BY_BRAND: ",
          action.data
        );
      }

      let newState = {
        rentalAssetsInTheBrand: {
          status: { status: APICallStatus.INIT },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.START_RENTAL_ASSETS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.START_RENTAL_ASSETS_BY_BRAND: ",
          action.data
        );
      }

      let newState = {
        rentalAssetsInTheBrand: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.GET_GROUPS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log("PUBLIC_ASSET_ACTIONS.GET_GROUPS_BY_BRAND: ", action.data);
      }

      let assets = action.data.response;
      return {
        ...state,
        groupsInTheBrand: {
          pageNumber:
            assets && assets.length
              ? action.data.pageNumber
              : state.groupsInTheBrand.pageNumber,
          data: assets,
          status: checkApiStatus(action.data.ajaxStat, null),
        },
      };
    }
    case PUBLIC_ASSET_ACTIONS.INIT_GROUPS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log("PUBLIC_ASSET_ACTIONS.INIT_GROUPS_BY_BRAND: ", action.data);
      }

      let newState = {
        groupsInTheBrand: {
          status: { status: APICallStatus.INIT },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.START_GROUPS_BY_BRAND: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.START_GROUPS_BY_BRAND: ",
          action.data
        );
      }

      let newState = {
        groupsInTheBrand: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.GET_TRADING_ASSETS: {
      if (config.APP_DEBUG) {
        console.log("PUBLIC_ASSET_ACTIONS.GET_TRADING_ASSETS: ", action.data);
      }

      let assets = action.data.response;
      return {
        ...state,
        tradingAssets: {
          pageNumber:
            assets && assets.length
              ? action.data.pageNumber
              : state.tradingAssets.pageNumber,
          data: assets,
          status: checkApiStatus(action.data.ajaxStat, null),
        },
      };
    }

    case PUBLIC_ASSET_ACTIONS.INIT_TRADING_ASSETS: {
      if (config.APP_DEBUG) {
        console.log("PUBLIC_ASSET_ACTIONS.INIT_TRADING_ASSETS: ", action.data);
      }

      let newState = {
        tradingAssets: {
          status: { status: APICallStatus.INIT },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.START_TRADING_ASSETS: {
      if (config.APP_DEBUG) {
        console.log("PUBLIC_ASSET_ACTIONS.START_TRADING_ASSETS: ", action.data);
      }

      let newState = {
        tradingAssets: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.GET_TRADABLE_LISTED_ASSETS: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.GET_TRADABLE_LISTED_ASSETS: ",
          action.data
        );
      }

      let assets = action.data.response;
      return {
        ...state,
        tradableListedAssets: {
          pageNumber:
            assets && assets.length
              ? action.data.pageNumber
              : state.tradableListedAssets.pageNumber,
          data: assets,
          status: checkApiStatus(action.data.ajaxStat, null),
        },
      };
    }

    case PUBLIC_ASSET_ACTIONS.INIT_TRADABLE_LISTED_ASSETS: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.INIT_TRADABLE_LISTED_ASSETS: ",
          action.data
        );
      }

      let newState = {
        tradableListedAssets: {
          status: { status: APICallStatus.INIT },
        },
      };
      return merge({}, state, newState);
    }
    case PUBLIC_ASSET_ACTIONS.START_TRADABLE_LISTED_ASSETS: {
      if (config.APP_DEBUG) {
        console.log(
          "PUBLIC_ASSET_ACTIONS.START_TRADABLE_LISTED_ASSETS: ",
          action.data
        );
      }

      let newState = {
        tradableListedAssets: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    default:
      return state;
  }
};
